<div>
  <p-toast></p-toast>
  <p-confirmDialog #cd [style]="{'max-width': '60vw', 'width': '60vw'}" styleClass="custom-confirm-dialog">
    <ng-template pTemplate="headless" let-message>
      <div class="flex flex-col items-center p-8 bg-white rounded-2xl relative">
        <div
          class="absolute -top-10 w-24 h-24 rounded-full bg-gradient-to-br from-orange-400 to-orange-600 flex items-center justify-center shadow-lg animate-bounce-in">
          <i class="pi pi-exclamation-triangle text-5xl text-white"></i>
        </div>
        <div class="mt-16 text-center w-full">
          <h3 class="text-2xl font-bold text-gray-900 mb-3">
            {{ message.header }}
          </h3>
          <p class="text-base text-gray-600 leading-relaxed px-4 mb-6">
            {{ message.message }}
          </p>
          <div class="flex items-center justify-center gap-3 mt-6">
            <button pButton type="button" [label]="message.acceptLabel || 'Yes, Continue'"
              (click)="message.accept && message.accept()"
              class="px-8 py-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl hover:from-orange-600 hover:to-orange-700 transition-all duration-200 transform hover:-translate-y-0.5">
            </button>
            <button *ngIf="message.rejectVisible !== false" pButton type="button"
              [label]="message.rejectLabel || 'Cancel'" (click)="message.reject && message.reject()"
              class="px-8 py-3 bg-white text-gray-700 font-semibold rounded-lg border-2 border-gray-300 hover:bg-gray-50 hover:border-gray-400 transition-all duration-200">
            </button>
          </div>
        </div>
      </div>
    </ng-template>
  </p-confirmDialog>

  <app-tool-bar [title]="'Lead Manager'" [iconName]="'pi-users'" [isSearch]="true" [isDateFilter]="true"
    [isImport]="true" [isExport]="true" [selectedProducts]="selectedProducts" [isBulkAction]="true" [isFilter]="true"
    (bulkUpload)="handleOpenBulkAdd()" (handleBulkAction)="handleBulkAction($event)" [bulkActionItems]="bulkActionItems"
    (ExportData)="export($event)" [filtersOptions]="filtersOptions" [isAdd]="true" [isFindDuplicate]="true"
    [duplicateCount]="duplicateCount" [filterOptions]="filterOptions" [exportItems]="exportItems"
    (handleAdd)="fnHandleAddd()" (handleFindDuplicate)="handleFindDuplicates()" (search)="handleSearch($event)"
    (dateFilter)="handleDateFilter($event)" (resetDateFilter)="handleResetFilters()"
    (applyFilter)="handleApplyFilter($event)" (clearFilter)="handleClearFilter()"></app-tool-bar>
</div>

<div class="p-4 overflow-auto h-[85vh]">
  <div class="tab-container ">
    <!-- class="outer-tab" -->
    <!-- [ngClass]="{ 'active': activeTab === tab.value }" -->
    <div *ngFor="let tab of tabs" class="outer-tab flex items-center" [ngClass]="{ 'active': activeTab === tab.value,
      'inactive': activeTab !== tab.value
     }" (click)="setActiveTab(tab.value)">
      <div class="tab">
        {{ tab.label }}
        <div *ngIf="tab.value != 'All Leads'">
          <i class="pi pi-pencil" style="color: red;" (click)="menuTab.toggle($event)"></i>
          <p-menu appendTo="body" #menuTab [model]="tabItems" [popup]="true" />
        </div>
      </div>

    </div>

    <div class="flex items-center">
      <div class="add-lead-space-outer" (click)="op.toggle($event)">
        <div class="add-lead-space-inner">
          <i class="pi pi-plus add-lead-space"></i>
        </div>
      </div>
    </div>

    <p-popover #op appendTo="body" class="lead-group-popover">
      <div class="p-0 min-w-[300px]">
        <div class="create-new-grp-header text-center">
          Create New Group
        </div>

        <div class="p-5">
          <div class="mb-2 font-medium">Enter Group Name</div>
          <input pInputText class="w-full gray-input" [(ngModel)]="newGroupName" />

          <div class="flex justify-between mt-4">
            <div>
              <p-button label="Close" variant="outlined" severity="danger" class="mt-4" (click)="op.toggle($event)" />
            </div>
            <div>
              <p-button label="Create" [loading]="isAddSpace" (click)="handleAddGroup($event)"
                [disabled]="!newGroupName || isAddSpace" icon="pi pi-check" class="w-full mt-4" />
            </div>

          </div>
        </div>

      </div>
    </p-popover>

  </div>


  <div>


    <p-table [value]="leadsData" [paginator]="true" [rows]="rows" [totalRecords]="totalRecords" [lazy]="true"
      (onLazyLoad)="loadLeads($event)" [(selection)]="selectedProducts" [loading]="loading"
      [rowsPerPageOptions]="totalRecords > 10 ? [10, 20, 50] : undefined" [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
      <ng-template pTemplate="header">
        <tr style="height: 60px;">
          <th style="width: 4rem; border-top-left-radius: 10px; padding: 1rem;"><p-tableHeaderCheckbox /></th>
          <th *ngFor="let col of displayedColumns" [pSortableColumn]="col.sortable ? col.field : ''" style="padding: 1rem; font-weight: 600; font-size: 0.95rem;">
            {{ col.header }}
            <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-customer let-i="rowIndex" let-rowData>
        <tr [ngClass]="{'disabled-row': rowData.current_stage !== 'lead'}" class="z-10" style="height: 65px;"
          [style.opacity]="rowData.current_stage !== 'lead' ? '0.5' : '1'"
          [style.pointer-events]="rowData.current_stage !== 'lead' ? 'none' : 'auto'">
          <td style="padding: 1rem;">
            <p-tableCheckbox [value]="customer" [disabled]="rowData.current_stage !== 'lead'" />
          </td>
          <td *ngFor="let col of displayedColumns" style="padding: 1rem; vertical-align: middle;">
            <ng-container [ngSwitch]="col.type">
              <!-- Handle Nested Object (Lead Owner) -->

              <!-- lead_id -->
              <ng-container *ngSwitchCase="'lead_id'">
                <div style="min-width: 100px;">
                  <a (click)="openLeadProfile(rowData)" class="text-blue-700 underline cursor-pointer">
                    ID:- {{ rowData[col.field] || 'N/A' }}
                  </a>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'nested'">
                {{ (rowData.user?.prefix ?? 'N/A') +
                (rowData.user?.fname ? ' ' + rowData.user.fname : '') +
                (rowData.user?.lname ? ' ' + rowData.user.lname : '') }}
              </ng-container>

              <ng-container *ngSwitchCase="'assigned_to'">
                {{ (rowData.assignedUser?.prefix ?? 'N/A') +
                (rowData.assignedUser?.fname ? ' ' + rowData.assignedUser.fname : '') +
                (rowData.assignedUser?.lname ? ' ' + rowData.assignedUser.lname : '') }}
              </ng-container>

              <ng-container *ngSwitchCase="'contact_name'">
                {{ getFullName(rowData) }}
              </ng-container>

              <ng-container *ngSwitchCase="'status'">
                <div class="flex items-center gap-1 rounded-full px-5 py-[1px] w-fit min-w-[120px] font-medium"
                  [style.borderWidth]="'2px'" [style.borderStyle]="'solid'"
                  [style.borderColor]="rowData.current_stage !== 'lead' ? '#888' : getStatusColor(rowData[col.field])"
                  [style.color]="rowData.current_stage !== 'lead' ? '#888' : getStatusColor(rowData[col.field])"
                  style="font-weight: 500;">
                  <div style="margin-top: 2px;">
                    <svg width="25px" height="25px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                      <g [attr.stroke]="rowData.current_stage !== 'lead' ? '#888' : getStatusColor(rowData[col.field])"
                        stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path
                          d="M12,13 C9.23857625,13 7,10.7614237 7,8 C7,5.23857625 9.23857625,3 12,3 C14.7614237,3 17,5.23857625 17,8 C17,10.7614237 14.7614237,13 12,13 Z M11.0150512,21 C9.04777237,21 6.37608863,21 3,21 C3.79921286,17.89195 6.4614209,16.2328962 10.9866241,16.0228387">
                        </path>
                        <polyline points="21.0037832 16.5969533 17 21 14.4906972 18.5114193"></polyline>
                      </g>
                    </svg>
                  </div>
                  {{
                  rowData.current_stage !== 'lead' ? 'Moved' : (rowData[col.field] || 'N/A')
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'source'">
                <img [src]="getLeadSourceImg(rowData[col.field])"
                     class="h-[33px] w-[30px] object-contain"
                     [pTooltip]="rowData[col.field]"
                     tooltipPosition="top" />
              </ng-container>

              <ng-container *ngSwitchCase="'date'">
                {{
                rowData[col.field] | date: 'dd/MM/yyyy'
                }}
              </ng-container>

              <ng-container *ngSwitchCase="'communicate'">
                <div class="flex gap-3 font-semibold ml-3 justify-center items-center z-50">
                  <i class="pi pi-phone" [style.color]="rowData.current_stage !== 'lead' ? '#ccc' : '#F0950C'"
                    [style.cursor]="rowData.current_stage !== 'lead' ? 'not-allowed' : 'pointer'"
                    style="font-weight: 600; font-size: 1rem;"
                    (click)="rowData.current_stage === 'lead' ? handleCallLead(rowData) : null"
                    *ngIf="accessObject.isCallAccess"></i>
                  <i class="pi pi-whatsapp" [style.color]="rowData.current_stage !== 'lead' ? '#ccc' : '#1FAF38'"
                    [style.cursor]="rowData.current_stage !== 'lead' ? 'not-allowed' : 'pointer'"
                    (click)="rowData.current_stage === 'lead' ? handleWhatsappLead(rowData) : null"
                    style="font-weight: 600; font-size: 1rem;"></i>
                  <i class="pi pi-envelope" [style.color]="rowData.current_stage !== 'lead' ? '#ccc' : '#0960BD'"
                    [style.cursor]="rowData.current_stage !== 'lead' ? 'not-allowed' : 'pointer'"
                    (click)="rowData.current_stage === 'lead' ? handleEmailLead(rowData) : null"
                    *ngIf="accessObject.isEmailAccess" style="font-size: 1rem; font-weight: 600;"></i>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'dynamic_fields'">
                {{
                rowData?.['dynamic_fields']?.[col.field] || 'N/A'
                }}
              </ng-container>

              <!-- Handle Boolean -->
              <ng-container *ngSwitchCase="'number'">
                {{
                rowData[col.field] || 0
                }}
              </ng-container>

              <ng-container *ngSwitchCase="'query_type'">
                {{
                rowData[col.field] || 'N/A'
                }}
              </ng-container>

              <!-- Lead Score -->
              <ng-container *ngSwitchCase="'lead_score'">
                <div class="flex items-center gap-2">
                  <span class="px-2 py-1 rounded-full text-xs font-semibold" [ngClass]="{
        'bg-green-100 text-green-600': rowData[col.field] >= 70,
        'bg-yellow-100 text-yellow-600': rowData[col.field] >= 40 && rowData[col.field] < 70,
        'bg-red-100 text-red-600': rowData[col.field] < 40
      }">
                    {{ rowData[col.field] || 0 }}
                  </span>

                  <span class="text-sm text-gray-600">/100</span>
                </div>
              </ng-container>



              <ng-container *ngSwitchCase="'placeholder'">
                {{
                rowData[col.field] || 'N/A'
                }}
              </ng-container>

              <!-- Handle Actions -->
              <ng-container *ngSwitchCase="'actions'">
                <div *ngIf="!loading" (click)="rowData.current_stage === 'lead' ? setLeadEditData(rowData) : null" class="flex justify-center">
                  <p-menu [tabindex]="undefined" #menu [model]="leadActionItems" [popup]="true"
                    appendTo="body"></p-menu>
                  <button 
                    (click)="rowData.current_stage === 'lead' ? menu.toggle($event) : null"
                    [disabled]="rowData.current_stage !== 'lead'"
                    class="inline-flex items-center justify-center w-9 h-9 rounded-full transition-all duration-200 ease-in-out"
                    [ngClass]="{
                      'bg-gray-100 hover:bg-blue-50 hover:shadow-md cursor-pointer': rowData.current_stage === 'lead',
                      'bg-gray-50 cursor-not-allowed opacity-50': rowData.current_stage !== 'lead'
                    }">
                    <i class="pi pi-ellipsis-h text-lg"
                      [ngClass]="{
                        'text-gray-700 hover:text-blue-600': rowData.current_stage === 'lead',
                        'text-gray-400': rowData.current_stage !== 'lead'
                      }"></i>
                  </button>
                </div>
              </ng-container>

              <!-- Default Case (Normal Field) -->
              <ng-container *ngSwitchDefault>
                {{ rowData[col.field] }}
              </ng-container>
            </ng-container>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="loading">
        <tr>
          <td colspan="3" class="text-center">
            <p-progressSpinner></p-progressSpinner>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="displayedColumns.length + 1" class="no-data">
            <p>No records found</p>
          </td>
        </tr>
      </ng-template>
    </p-table>

  </div>

  <app-floating-configurator />



</div>

<p-dialog [modal]="true" [(visible)]="isOpenAddDialog" [breakpoints]="{ '1199px': '80vw', '575px': '90vw' }"
  closable="false" [style]="{ width: '70vw' }" [draggable]="false" [resizable]="false">
  <app-add-lead (closeDialog)="isOpenAddDialog = false" [formAction]="'Add'" [allLeadFeilds]="allLeadFeilds"
    [selectedDefaultPipelineId]="selectedDefaultPipelineId" [pipelineStages]="pipelineStages" [users]="users"
    (reload)="reloadDataTable()"></app-add-lead>
</p-dialog>

<p-dialog [modal]="true" [(visible)]="isEditLead" [breakpoints]="{ '1199px': '80vw', '575px': '90vw' }" closable="false"
  [style]="{ width: '70vw' }" [draggable]="false" [resizable]="false">
  <ng-container *ngIf="isEditLead">
    <app-add-lead (closeDialog)="isEditLead = false" [editLeadData]="editLeadData" [formAction]="'Update'"
      [selectedDefaultPipelineId]="selectedDefaultPipelineId" [pipelineStages]="pipelineStages"
      [allLeadFeilds]="allLeadFeilds" [users]="users" (reload)="reloadDataTable()"></app-add-lead>
  </ng-container>
</p-dialog>



<p-dialog [modal]="true" [(visible)]="isDeleteLead" [breakpoints]="{ '1199px': '50vw', '575px': '90vw' }"
  closable="false" [style]="{ width: '40vw' }" [draggable]="false" [resizable]="false">
  <app-delete-lead (closeDialog)="isDeleteLead = false" [editLeadData]="editLeadData"
    (reload)="reloadDataTable()"></app-delete-lead>
</p-dialog>


<p-dialog [modal]="true" [(visible)]="isAddToLeadSpace" [breakpoints]="{ '1199px': '50vw', '575px': '90vw' }"
  closable="false" [style]="{ width: '40vw' }" [draggable]="false" [resizable]="false">
  <app-move-lead-space [tabs]="tabs" (closeDialog)="isAddToLeadSpace = false" [editLeadData]="editLeadData"
    (reload)="reloadDataTable()"></app-move-lead-space>
</p-dialog>

<p-dialog [modal]="true" [(visible)]="isOpenBulkAdd" [breakpoints]="{ '1199px': '60vw', '575px': '90vw' }"
  closable="false" [style]="{ width: '40vw' }" [draggable]="false" [resizable]="false">
  <ng-container *ngIf="isOpenBulkAdd">
  <app-bulk-upload (closeDialog)="isOpenBulkAdd = false" [users]="users" [displayedColumns]="importColumns"
    (reload)="reloadDataTable()" [allLeadFeilds]="allLeadFeilds"></app-bulk-upload>
  </ng-container>
</p-dialog>

<p-dialog [modal]="true" [(visible)]="isBulkUpdateLeads" [breakpoints]="{ '1199px': '60vw', '575px': '90vw' }"
  closable="false" [style]="{ width: '40vw' }" [draggable]="false" [resizable]="false">
  <app-bulk-update [title]="'Leads'" [isLeads]="true" [selectedProducts]="selectedProducts" [users]="users"
    [pipelineStages]="pipelineStages" [selectedDefaultPipelineId]="selectedDefaultPipelineId"
    (reload)="reloadDataTable()" (closeDialog)="isBulkUpdateLeads = false"></app-bulk-update>
</p-dialog>


<p-dialog [modal]="true" [(visible)]="isBulkDeleteLead" [breakpoints]="{ '1199px': '50vw', '575px': '90vw' }"
  closable="false" [style]="{ width: '40vw' }" [draggable]="false" [resizable]="false">
  <ng-container *ngIf="isBulkDeleteLead">
    <app-bulk-delete (closeDialog)="isBulkDeleteLead = false" [selectedProducts]="selectedProducts"
      (reload)="reloadDataTable()"></app-bulk-delete>
  </ng-container>
</p-dialog>


<p-dialog [modal]="true" [(visible)]="isUpdateLeadSpace" [breakpoints]="{ '1199px': '50vw', '575px': '90vw' }"
  closable="false" [style]="{ width: '40vw' }" [draggable]="false" [resizable]="false">
  <ng-container *ngIf="isUpdateLeadSpace">
    <app-update-lead-space (closeDialog)="isUpdateLeadSpace = false" [activeTab]="activeTab"
      [activeTabName]="activeTabName" (reloadTabs)="reloadTabs($event)"></app-update-lead-space>
  </ng-container>
</p-dialog>


<p-dialog [modal]="true" [(visible)]="isDeleteLeadSpace" [breakpoints]="{ '1199px': '50vw', '575px': '90vw' }"
  closable="false" [style]="{ width: '35vw' }" [draggable]="false" [resizable]="false">
  <ng-container *ngIf="isDeleteLeadSpace">
    <app-delete-lead-space (closeDialog)="isDeleteLeadSpace = false" [activeTab]="activeTab"
      [activeTabName]="activeTabName" (reloadTabs)="reloadTabsToAllLeads($event)"></app-delete-lead-space>
  </ng-container>
</p-dialog>

<p-dialog [modal]="true" [(visible)]="isBulkMoveLeadSpace" [breakpoints]="{ '1199px': '50vw', '575px': '90vw' }"
  closable="false" [style]="{ width: '35vw' }" [draggable]="false" [resizable]="false">
  <ng-container *ngIf="isBulkMoveLeadSpace">
    <app-move-bulk-lead-space (closeDialog)="isBulkMoveLeadSpace = false" [tabs]="tabs" (reload)="reloadDataTable()"
      [selectedProducts]="selectedProducts"></app-move-bulk-lead-space>
  </ng-container>
</p-dialog>


<p-dialog [modal]="true" [(visible)]="isBulkSendEmail" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  closable="false" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
  <app-lead-email (closeDialog)="isBulkSendEmail = false" [selectedProducts]="selectedProducts" [isBulk]="true"
    (removeSelectedProducts)="removeSelectedProducts()"></app-lead-email>
</p-dialog>


<p-dialog [modal]="true" [(visible)]="isEmailLead" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  closable="false" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
  <app-lead-email (closeDialog)="isEmailLead = false" [communicationData]="leadDetails"></app-lead-email>
</p-dialog>

<p-dialog [modal]="true" [(visible)]="isCallLead" [breakpoints]="{ '1199px': '50vw', '575px': '90vw', }"
  closable="false" [style]="{ width: '35vw' }" [draggable]="false" [resizable]="false">
  <app-lead-call (closeDialog)="isCallLead = false" [communicationData]="leadDetails"></app-lead-call>
</p-dialog>


<p-dialog [modal]="true" [(visible)]="isMoveToRegistration" [breakpoints]="{ '1199px': '50vw', '575px': '90vw', }"
  closable="false" [style]="{ width: '35vw' }" [draggable]="false" [resizable]="false">
  <app-move-to-registration (closeDialog)="isMoveToRegistration = false" [editLeadData]="editLeadData"
    (reload)="reloadDataTable()"></app-move-to-registration>
</p-dialog>



<p-dialog [modal]="true" [(visible)]="isBulkMoveToRegistration" [breakpoints]="{ '1199px': '50vw', '575px': '90vw', }"
  closable="false" [style]="{ width: '35vw' }" [draggable]="false" [resizable]="false">
  <app-bulk-move-to-registration (closeDialog)="isBulkMoveToRegistration = false" [selectedProducts]="selectedProducts"
    (reload)="reloadDataTable()"></app-bulk-move-to-registration>
</p-dialog>




<p-dialog [modal]="true" [(visible)]="isOpenFollowUpForm" [breakpoints]="{ '1199px': '70vw', '575px': '90vw', }"
  closable="false" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false" *ngIf="isOpenFollowUpForm">

  <div class="rounded-xl overflow-hidden shadow-lg">
    <!-- Header -->
    <div class="flex items-center justify-center dialog-header">
      Add Follow Up
      <div class="absolute right-4">
        <button (click)="isOpenFollowUpForm = false" class="text-white hover:text-gray-300">
          <i class="pi pi-times"></i>
        </button>
      </div>
    </div>
    <!-- Content -->
    <div class="dialog-content p-6 text-center">

      <app-lead-followup-form-popup (closeDialog)="isOpenFollowUpForm = false"
        [leadData]="editLeadData"></app-lead-followup-form-popup>
    </div>

  </div>
</p-dialog>



<p-dialog [modal]="true" *ngIf="isWhatsappLead" [(visible)]="isWhatsappLead"
  [breakpoints]="{ '1199px': '70vw', '575px': '90vw', }" closable="false" [style]="{ width: '60vw' }"
  [draggable]="false" [resizable]="false">
  <app-whatsapp-communication (closeDialog)="isWhatsappLead = false"
    [communicationData]="leadDetails"></app-whatsapp-communication>
</p-dialog>

<app-find-duplicate-leads (reload)="reloadDataTable(); loadDuplicateCount()" [(visible)]="isFindDuplicateLeads">
</app-find-duplicate-leads>